const technologies = {
  technologies: {
    header: {
      overline: "STACK TECH CORE",
      titlePrefix: "Propulser",
      titleHighlight: "l’intelligence",
      subtitle:
        "Un ensemble de technologies sélectionnées avec soin pour des solutions IA haute performance et des architectures web scalables.",
    },
    tabs: {
      all: "Tout",
      aiData: "IA & Data Science",
      backendCloud: "Backend & Cloud",
      frontendMobile: "Frontend & Mobile",
      languages: "Langages",
      devopsTools: "DevOps & Outils",
    },
    years: {
      one: "an",
      other: "ans",
    },
    cta: {
      titlePrefix: "Besoin d’une",
      titleHighlight: "stack sur mesure ?",
      subtitle:
        "Je conçois des architectures IA scalables adaptées à vos besoins. Discutons de vos exigences techniques.",
      button: "Obtenir un audit technique",
    },
  },
};

export default technologies;
